export default __webpack_public_path__ + "static/corporate-governance-mobile-banner-cbcf516356bde12660b0f146c30e6795.png";